import React, { Fragment } from 'react';
import MatchScore from 'library/components/target-match-score';
import { TargetDataLoading } from 'apps/personal/components/targets/target-data';

const TargetLoading = () => (
  <Fragment>
    <div className='personal-target-grouping personal-target-grouping-loading'>
      <MatchScore>00</MatchScore>
      <div className='personal-target-grouping-header'>
        <h3 className='personal-target-grouping-name'>
          loading
        </h3>
        <div className='personal-target-grouping-options'>
        </div>
      </div>
    </div>
    <div className='personal-target-grouping-targets personal-target-grouping-loading'>
      <TargetDataLoading />
    </div>
  </Fragment>
);

export default TargetLoading;
